<template>
    <div class="menu-item" :class="{ opened: expanded }">
      <div
        class="label"
        @click="toggleMenu()"
        :style="{ paddingLeft: depth * 20 + 20 + 'px' }"
      >
        <div class="left">
            <icon v-if="icon" :name="icon" class="hover:fill-white w-4 h-4 mr-2" />
      
            <a :href="url"> <span v-if="showLabel" >{{ label }} </span></a>
        </div>
        <div v-if="data" class="right">
            <icon name="cheveron-right" class="icone w-4 h-4 mr-2 hover:fill-inexgrayc" :class="{ opened: expanded }"/>
        </div>
      </div>
      <div
        v-show="showChildren"
        :class="{ 'small-menu': smallMenu }"
        class="items-container"
        :style="{ height: containerHeight }"
        ref="container"
      >
        <menu-item
          :class="{ opened: showChildren }"
          v-for="(item, index) in data"
          :key="index"
          :data="item.children"
          :label="item.label"
          :url="item.url"
          :icon="item.icon"
          :depth="depth + 1"
          :smallMenu="smallMenu"
        />
     
      </div>
    </div>
  </template>
  
  <script>
  import Icon from '@/Shared/Icon'
  export default {
    name: "menu-item",
    components: {
    Icon,
  },
    data: () => ({
      showChildren: false,
      expanded: false,
      containerHeight: 0,
    }),
    props: {
      data: {
        type: Array,
      },
      label: {
        type: String,
      },
      icon: {
        type: String,
      },
      url:{
        type: String,
      },
      depth: {
        type: Number,
      },
      smallMenu: {
        type: Boolean,
      },
    },
    computed: {
      showLabel() {
        return this.smallMenu ? this.depth > 0 : true;
      }
    },
    methods: {
      toggleMenu() {
        this.expanded = !this.expanded;
        if (!this.showChildren) {
          this.showChildren = true;
          this.$nextTick(() => {
            this.containerHeight = this.$refs["container"].scrollHeight + "px";
            setTimeout(() => {
              this.containerHeight = "fit-content";
              if(navigator.userAgent.indexOf("Firefox") != -1) 
                this.containerHeight = "-moz-max-content"
              this.$refs["container"].style.overflow = "visible";
            }, 300);
          });
        } else {
          this.containerHeight = this.$refs["container"].scrollHeight + "px";
          this.$refs["container"].style.overflow = "hidden";
          setTimeout(() => {
            this.containerHeight = 0 + "px";
          }, 10);
          setTimeout(() => {
            this.showChildren = false;
          }, 300);
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .menu-item {
    position: relative;
    width: 100%;
    .icone{
      color:#ffffff;
      &:hover {
        color: #ffffff;
        background: #d4d712;
        cursor: pointer;
      }
    }
    .label {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      white-space: nowrap;
      user-select: none;
      height: 50px;
      padding: 0 20px;
      box-sizing: border-box;
      font-size: 14px;
      color: #9c9c9c;
      transition: all 0.3s ease;
      > div {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      i {
        font-size: 20px;
        color: #6e6e6e;
        transition: all 0.3s ease;
        &.expand {
          font-size: 16px;
          color: #cacaca;
          &.opened {
            transform: rotate(180deg);
          }
        }
      }
      &.small-item {
        width: fit-content;
      }
      &:hover {
        color: #ffffff;
        background: #d4d712;
        cursor: pointer;
      }
    }
    .items-container {
      width: 100%;
      left: calc(100% + 6px);
      transition: height 0.3s ease;
      overflow: hidden;
      z-index: 2;
      &.small-menu {
        width: fit-content;
        position: relative;
        background: #000;
        box-shadow: 0 0 10px #ebebeb;
        border-radius: 5px;
        top: 0;
        .label {
          width: 100% !important;
          padding-left: 10px !important;
        }
      }
    }
  }
  </style>